import React from 'react';

import { SimpleCallback } from '../../../typings';
import { Button } from '../../button/button';
import { UI_KIT_TEXT_TYPOGRAPHY } from '../../constants';
import Modal from '../../modal/modal';
import Text from '../../text/text';

import './quiz-game-card__deletion-confirmation-modal.scss';

interface Props {
    onAccept: SimpleCallback;
    onClose: SimpleCallback;
    opened: boolean;
}

const { paragraphLRegular, paragraphXLRegular } = UI_KIT_TEXT_TYPOGRAPHY;

export const DeletionConfirmationModal = ({ onAccept, onClose, opened }: Props) => (
    <Modal
        mix="quiz-game-card__deletion-confirmation-modal"
        onRequestClose={onClose}
        opened={opened}
        theme={Modal.THEMES.TEACHER}
    >
        <Text id="quiz.deletionConfirmationModal.question" typography={paragraphXLRegular} />

        <footer className="quiz-game-card__deletion-confirmation-modal-footer">
            <Button
                className="quiz-game-card__deletion-confirmation-modal-button"
                onClick={onClose}
                size={Button.SIZE.L}
                view={Button.VIEW.SECONDARY}
            >
                <Text id="quiz.deletionConfirmationModal.reject" typography={paragraphLRegular} />
            </Button>
            <Button
                className="quiz-game-card__deletion-confirmation-modal-button"
                onClick={onAccept}
                size={Button.SIZE.L}
                view={Button.VIEW.ACTION}
            >
                <Text id="quiz.deletionConfirmationModal.accept" typography={paragraphLRegular} />
            </Button>
        </footer>
    </Modal>
);
